import React, {useEffect, useState} from "react";
import {BASE_URL, BUSINESS} from "../../constants";
import {reportErrors} from "../../helpers";
import Box from "@mui/material/Box";
import {Card, Stack} from "@mui/material";
import Typography from "@mui/material/Typography";
import Chart from "react-apexcharts";
import SelectField from "../../components/SelectField";
import Divider from "@mui/material/Divider";

export default function ReviewResponse(props) {
    const [data, setData] = useState([]);
    const [businessType, setBusinessType] = useState(window.$user?.company?.businessType);

    useEffect(() => {
        loadData();
    }, [businessType]);
    const loadData = () => {
        let url = `${BASE_URL}api/review-response?data=data`;
        if (businessType) {
            url += `&businessType=${businessType}`;
        }
        window.axios
            .get(url)
            .then((response) => {
                setData(response.data.data)
            })
            .catch((error) => {
                reportErrors(alert.current, error);
            });
    };
    return (
        <Box>
            <SelectField
                required={true}
                placeholder="Business Type"
                options={BUSINESS}
                value={businessType}
                onChange={(value) => setBusinessType(value)}
            />
            <Divider/>
            <Stack spacing={2} sx={{p: 2}}>
                {data.map((e, index) => (
                    <>
                        <Typography>{index + 1}. {e.name}</Typography>
                        <Card><Chart options={{labels: [...e?.answers]}} series={[...e?.answerValue]} type="donut"
                                     width="450"/></Card>
                    </>
                ))}
            </Stack>
        </Box>
    );
}